export default __webpack_public_path__ + "static/media/ksztalty-standard.ee1a893f.svg";